function checkForAFGRule() {
  console.log("Check for AFG...", (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules));
  if (window.tlAdvancedFreeGift) {
    clearInterval(intervalId);

    // Override render method: Only render a rule if it can be applied or has been applied
    window.tlAdvancedFreeGift.render = async () => {
      // Check for rules that can be applied with this product
      const currentProductId = window.tlAdvancedFGProductId;
      const currentProductCollection = window.tlAdvancedFGCollectionsOfProduct;
      let canBeAppliedRules = [];

      const appliedProductList = (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules)
        .filter((rule) => rule.apply_to_product === "product")
        .flatMap((item) => item.listParents.map((parent) => parent.shopify_id));
      const appliedCollectionList = (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules)
        .filter((rule) => rule.apply_to_product === "collection")
        .flatMap((item) => item.listParents.map((parent) => parent.shopify_id));

      if (appliedProductList.includes(currentProductId)) {
        canBeAppliedRules = (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules)
          .filter((rule) => {
            return (
              rule.apply_to_product === "product" &&
              rule.listParents.some(
                (parent) => parent.shopify_id === currentProductId
              )
            );
          })
          .map((rule) => rule.id);
      } else if (
        currentProductCollection.some((collectionId) =>
          appliedCollectionList.includes(collectionId)
        )
      ) {
        canBeAppliedRules = (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules)
          .filter((rule) => {
            return (
              rule.apply_to_product === "collection" &&
              rule.listParents.some((parent) =>
                currentProductCollection.includes(parent.shopify_id)
              )
            );
          })
          .map((rule) => rule.id);
      }
      // Check for rules that can be applied with this product
      console.log("canBeAppliedRules", canBeAppliedRules);

      const bodyElement = document.querySelector(".salepify-fg-advanced-body");
      bodyElement.innerHTML = '<div class="loader"></div>';
      let bodyHtml = "";
      const listRuleNeedToAddGift = [];
      const listRuleNeedToRemoveGift = [];

      let availableToClaim = [];
      let needToReload = false;
      let hasRuleMetCondition = false;
      let claimedRule = false;
      for (let i = 0; i < (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules).length; i++) {
        const rule = (window.tlAdvancedFreeGift&&window.tlAdvancedFreeGift.rules)[i];
        const ruleId = rule.id;

        const [
          conditionState,
          claimedCount,
          canClaimCount,
          remain,
          remainSpecific,
        ] = window.tlAdvancedFreeGift.getRemain(rule);

        if (claimedCount < canClaimCount) {
          rule.auto_add_gift ? listRuleNeedToAddGift.push(ruleId) : null;
        } else if (claimedCount > canClaimCount) {
          rule.auto_remove_gift
            ? listRuleNeedToRemoveGift.push({
                id: ruleId,
                removeTime: claimedCount - canClaimCount,
              })
            : null;
        }

        // Store handle of parent and child product
        const uniqueProductHandle = new Set();

        // Store list parent id in order current product => required => rest product
        const listChildDisplayIds = [];
        // ChildId map quantity required
        const childMapRequiredQty = {};

        if (rule.gift_type == window.tlAdvancedFreeGift.GIFT_TYPE.COLLECTION) {
        } else {
          rule.listChilds.map((child) => {
            listChildDisplayIds.push(child.shopify_id);
            if (
              !window.tlAdvancedFreeGift.shopifyIdMapData.get(child.product_id)
            ) {
              uniqueProductHandle.add(child.handle);
            }
            if (child.quantity) {
              childMapRequiredQty[child.shopify_id] = child.quantity;
            }
          });
        }

        // ParentId map quantity required
        const parentMapRequiredQty = {};

        const requireParents = [];
        const highPriorityParents = [];
        const lowPriorityParents = [];
        const productIdKey =
          rule.apply_to_product ===
          window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT
            ? "shopify_id"
            : "product_id";

        if (
          rule.apply_to_product ===
            window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.PRODUCT ||
          rule.apply_to_product ===
            window.tlAdvancedFreeGift.APPLY_TO_PRODUCT.VARIANT
        ) {
          rule.listParents.map((parent) => {
            const productId = parent[productIdKey];
            if (!window.tlAdvancedFreeGift.shopifyIdMapData.get(productId)) {
              uniqueProductHandle.add(parent.handle);
            }

            if (productId == window.tlAdvancedFreeGift.currentProductId) {
              parent.quantity
                ? requireParents.unshift(parent.shopify_id)
                : highPriorityParents.unshift(parent.shopify_id);
            } else {
              parent.quantity
                ? requireParents.push(parent.shopify_id)
                : lowPriorityParents.push(parent.shopify_id);
            }
            parentMapRequiredQty[parent.shopify_id] = parent.quantity;
          });
        }

        const listParentDisplayIds = [
          ...requireParents,
          ...highPriorityParents,
          ...lowPriorityParents,
        ];
        await window.tlAdvancedFreeGift.updateProductData(
          Array.from(uniqueProductHandle)
        );
        if (
          rule.show_free_gift_widget &&
          window.tlAdvancedFreeGift.checkShowOnPage(rule.show_on_pages)
        ) {
          if (claimedCount < canClaimCount && !rule.auto_add_gift) {
            hasRuleMetCondition = true;
          }
          console.log(
            canBeAppliedRules.includes(ruleId) &&
              claimedCount == canClaimCount &&
              claimedCount == rule.maximum_per_order
          );
          if (
            canBeAppliedRules.includes(ruleId) &&
            claimedCount == canClaimCount &&
            claimedCount == rule.maximum_per_order
          ) {
            claimedRule = true;
          }
          const totalGift =
            rule.gift_qty *
            window.tlAdvancedFreeGift.ruleIdMapCanClaimTime.get(ruleId);
          const translation =
            window.tlAdvancedFreeGift.getRuleTranslation(ruleId);
          const gifts = await window.tlAdvancedFreeGift.getGifts(
            rule,
            listChildDisplayIds,
            childMapRequiredQty
          );

          bodyHtml += `
                      <div id="salepify-fg-advanced-main-section-${ruleId}"  
                          class="salepify-fg-advanced-main-section block--flex salepify-fg-advanced-main-section--view-more 
                          ${
                            conditionState !==
                            window.tlAdvancedFreeGift.CONDITION_STATE.NOT_MET
                              ? " salepify-fg-advanced-main-section--allow-claim"
                              : ""
                          }
                          ${
                            conditionState ===
                            window.tlAdvancedFreeGift.CONDITION_STATE
                              .MET_AFFTER_CLAIM
                              ? " salepify-fg-advanced-main-section--claimed"
                              : ""
                          }" 
                          style="${
                            canBeAppliedRules.includes(ruleId)
                              ? ""
                              : "display:none"
                          }"
                      >
                          <div class="block--flex-inline flex--space-between">
                              <div class= "salepify-fg-advanced-main-section__offer-title text--bold">
                                  ${
                                    conditionState ===
                                    window.tlAdvancedFreeGift.CONDITION_STATE
                                      .NOT_MET
                                      ? window.tlAdvancedFreeGift.handleReplaceVariable(
                                          rule,
                                          window.tlAdvancedFreeGift.getOfferTitle(
                                            rule
                                          ),
                                          remain,
                                          remainSpecific,
                                          totalGift
                                        )
                                      : translation.main_offer
                                          .eligible_offer_title
                                  }
                              </div>
                              
                              <div 
                                  class="salepify-fg-advanced-main-section__view-offer-btn btn--plain" 
                                  onclick='window.tlAdvancedFreeGift.handleViewMore("${ruleId}")'
                              >
                                  ${
                                    i == 0
                                      ? translation.main_offer.view_less
                                      : translation.main_offer.view_more
                                  }
                              </div>
                          </div>
                          
                          <div class="salepify-fg-advanced-offer block--flex-inline">
                              ${window.tlAdvancedFreeGift.renderOffer(
                                listParentDisplayIds
                              )}
                          </div>
  
                          <div class="divider"></div>
                          
                          <div class="salepify-fg-advanced-customer-buy block--flex block--collapsible">
                              ${window.tlAdvancedFreeGift.renderCustomerBuy(
                                listParentDisplayIds,
                                parentMapRequiredQty
                              )}
                          </div>
  
                          <div class="salepify-fg-advanced-main-section__upsell-banner">
                              ${window.tlAdvancedFreeGift.handleReplaceVariable(
                                rule,
                                window.tlAdvancedFreeGift.renderUpsellMsg(
                                  conditionState,
                                  rule
                                ),
                                remain,
                                remainSpecific,
                                totalGift
                              )}
                          </div>
  
                          <div class="salepify-fg-advanced-gift-list block--flex block--collapsible" 
                              ${
                                rule.gift_type ==
                                window.tlAdvancedFreeGift.GIFT_TYPE.COLLECTION
                                  ? `onscroll="window.tlAdvancedFreeGift.handleLoadingGift(${ruleId})"`
                                  : ""
                              }
                          >
                              ${window.tlAdvancedFreeGift.renderGifts(
                                rule,
                                gifts,
                                conditionState
                              )}
                          </div>
                        
                          <div class="salepify-fg-advanced-footer block--flex-inline flex--space-between block--collapsible"
                              style="display: ${
                                conditionState !==
                                  window.tlAdvancedFreeGift.CONDITION_STATE
                                    .NOT_MET && !rule.auto_add_gift
                                  ? "flex"
                                  : "none"
                              }"
                          >
                              <div class="salepify-fg-advanced-footer__remain-gift-title">
                                  ${
                                    translation.manual_choose_gift.selected_text
                                  } 
                                  ${
                                    conditionState !==
                                    window.tlAdvancedFreeGift.CONDITION_STATE
                                      .MET_AFFTER_CLAIM
                                      ? window.tlAdvancedFreeGift.getTotalSelectedGift(
                                          ruleId
                                        )
                                      : totalGift
                                  }/${totalGift}
                              </div>
  
                              ${
                                conditionState ===
                                window.tlAdvancedFreeGift.CONDITION_STATE
                                  .MET_BEFORE_CLAIM
                                  ? `<div class="salepify-fg-advanced-footer__claim-btn btn--fake" onclick='window.tlAdvancedFreeGift.handleAddGiftAndReload(${ruleId})'>
                                          ${translation.manual_choose_gift.claim_btn}
                                      </div>`
                                  : `<div class="salepify-fg-advanced-footer__claim-btn salepify-fg-advanced-footer__claim-btn--claimed">
                                          ${translation.manual_choose_gift.claimed_btn}
                                      </div> `
                              }
                          </div>
                          <div id="salepify-fg-advanced-error-${ruleId}">
                              <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512">
                                  <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/>
                              </svg>
                              <span class="salepify-fg-advanced-error__message"></span>
                          </div>
                      </div>
                  `;

          if (
            conditionState ==
            window.tlAdvancedFreeGift.CONDITION_STATE.MET_BEFORE_CLAIM
          )
            availableToClaim.push(ruleId);
        } else {
          needToReload = window.tlAdvancedFreeGift.updateSelectedGifts(rule);
        }
      }

      if (listRuleNeedToAddGift.length) {
        if (window.tlAdvancedFreeGift.itemsInTempCart.size) {
          listRuleNeedToAddGift.map((ruleId) => {
            window.tlAdvancedFreeGift.updateGiftsInTempCart(ruleId, true);
          });
        } else {
          const addCartReq = await window.tlAdvancedFreeGift.handleAddGift(
            listRuleNeedToAddGift
          );
          if (addCartReq.status === 200) {
            if (
              window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation
            ) {
              window.tlAdvancedFreeGift.showConfetti();
            }
            window.tlAdvancedFreeGift.showIconPopUpMessage(
              "You’ve received a gift. Please reload to view the changes.",
              availableToClaim.length
            );
            if (needToReload) {
              if (!window.TLCustomEventGiftsAdvanced) {
                window.location.reload();
              } else if (window.TLCustomEventGiftsAdvanced == 1) {
                window.dispatchEvent(
                  new CustomEvent(
                    "TLCustomEvent:FreeGiftsAdvanced-render-needToReload"
                  )
                );
              }
            }
          } else {
            // Return error if there are not enough gift to add
            const addCartRes = await addCartReq.json();
            window.tlAdvancedFreeGift.showIconPopUpMessage(
              addCartRes.description,
              1
            );
          }
        }
      } else {
        if (availableToClaim.length) {
          const manualText = window.tlAdvancedFreeGift.getRuleTranslation(
            availableToClaim[0]
          ).gift_icon.manual;
          window.tlAdvancedFreeGift.showIconPopUpMessage(
            manualText,
            availableToClaim.length
          );
        } else {
          window.tlAdvancedFreeGift.iconPopupBadgeElement.style =
            "display: none";
        }
      }

      if (!claimedRule)
        if (bodyHtml) {
          const popupIcon = document.querySelector(
            ".salepify-fg-advanced-icon-popup__icon"
          );

          popupIcon.style.display =
            window.tlAdvancedFreeGift.displaySettings.icon_popup
              .is_icon_displayed && canBeAppliedRules.length
              ? "block"
              : "none";
          window.tlAdvancedFreeGift.iconPopupElement.style.display =
            canBeAppliedRules.length ? "flex" : "none";
          window.tlAdvancedFreeGift.iconPopupElement.style.backgroundImage =
            window.tlAdvancedFreeGift.displaySettings.icon_popup
              .is_icon_displayed
              ? "none"
              : `url(${window.tlAdvancedFreeGift.displaySettings.icon_popup.adv_free_gift_image.url})`;

          bodyElement.innerHTML = bodyHtml;

          if (hasRuleMetCondition) {
            if (
              window.tlAdvancedFreeGift.displaySettings?.show_confetti_animation
            ) {
              window.tlAdvancedFreeGift.showConfetti();
            }
            window.tlAdvancedFreeGift.openGiftModal();
            window.tlAdvancedFreeGift.isAutoOpenPopup = true;
          }
        }

      if (
        listRuleNeedToRemoveGift.length &&
        !window.tlAdvancedFreeGift.itemsInTempCart.size
      ) {
        await window.tlAdvancedFreeGift.handleRemoveGift(
          listRuleNeedToRemoveGift
        );
        if (!window.TLCustomEventGiftsAdvanced) {
          window.location.reload();
        } else if (window.TLCustomEventGiftsAdvanced == 1) {
          window.dispatchEvent(
            new CustomEvent(
              "TLCustomEvent:FreeGiftsAdvanced-render-needToRemoveGift"
            )
          );
        }
      }
    };

    if (
      window.location.href.startsWith(
        "https://israel-gift.myshopify.com/products/"
      )
    ) {
      window.tlAdvancedFreeGift.render();
    }
  }
}

const intervalId = setInterval(checkForAFGRule, 100);
setTimeout(() => {
  clearInterval(intervalId);
}, 5000);

// Refresh cart
window.TLCustomEventCartGoal = 1;
window.addEventListener(
  "TLCustomEvent:CartGoal-getPassedMilestone",
  (event) => {
    window.location.reload();
  }
);
window.addEventListener("TLCustomEvent:CartGoal-handleAutoAddGift", (event) => {
  window.location.reload();
});
window.addEventListener("TLCustomEvent:CartGoal-handleAddtoCart", (event) => {
  if (window.location.pathname === "/cart") {
    window.location.reload();
  } else {
    fetch(`/?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((carthtml) => {
        const parser = new DOMParser();
        const parsedHtml = parser.parseFromString(carthtml, "text/html");
        document.querySelector("#cart-drawer .cart-drawer__items").innerHTML =
          parsedHtml.querySelector(
            "#cart-drawer .cart-drawer__items"
          ).innerHTML;
        window.tlCartGoalEmbed.updateCartTotal();
        window.tlCartGoalEmbed.renderAllCartGoals();
      });
  }
});
window.addEventListener(
  "TLCustomEvent:CartGoal-handleApplyDiscountCode",
  (event) => {
    window.location.reload();
  }
);

function changeCurrency() {
  const foundProgressBarProcess = setInterval(() => {
    console.log("Start convert currency..");
    const progressBarDescript = document.querySelectorAll(
      ".tl__cart-goal__reward-description__drawer, .tl__cart-goal__goal-check-point-value"
    );
    if (progressBarDescript.length) {
       console.log("Found..");
      clearInterval(foundProgressBarProcess);
      progressBarDescript.forEach((element) => {
        if (element.textContent.includes("ILS")) {
          element.textContent = element.textContent.replace(/ILS/g, "₪");
        }
      });
    }
  }, 500);
  setTimeout(() => {
    clearInterval(foundProgressBarProcess);
  }, 5000);
}
changeCurrency()
function observeElementChange(selector, callback) {
        const targetNode = document.querySelector(selector);
        if (!targetNode) return;

        const observer = new MutationObserver(mutationsList => {
            for (let mutation of mutationsList) {
                if (mutation.type === "childList" || mutation.type === "characterData") {
                    callback(mutation.target);
                }
            }
        });

        observer.observe(targetNode, { childList: true, subtree: true, characterData: true });
    }
observeElementChange("#cart-drawer", function (element) {
        changeCurrency()
});